export default __webpack_public_path__ + "static/media/spending-limits.64eff82e.svg";